// extracted by mini-css-extract-plugin
export default {"root":"switchLanguage_root__Rz0uk","lan":"switchLanguage_lan__EzkgJ","choose":"switchLanguage_choose__eb+OS"};